const intl = {
  swe: 'sv-SE',
  eng: 'en-GB',
} as {
  [key: string]: string;
};

function formatDateRange(dateRangeString: string, lang: string) {
  const [startDateStr, endDateStr] = dateRangeString.split(' - ');

  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  const startDay = startDate.getUTCDate();
  const startMonth = startDate.getUTCMonth();
  const startYear = startDate.getUTCFullYear();

  const startMonthShort = new Date(startYear, startMonth, startDay).toLocaleString(intl[lang], { month: 'short' });
  const endDay = endDate.getUTCDate();
  const endMonth = endDate.getUTCMonth();
  const endYear = endDate.getUTCFullYear();

  const endMonthShort = new Date(endYear, endMonth, endDay).toLocaleString(intl[lang], { month: 'short' });

  if (startDateStr === endDateStr) return `${startDay} ${startMonthShort}  ${startYear}`;
  if (endMonth !== startMonth && startYear !== endYear) return `${startDay} ${startMonthShort} ${startYear}  - ${endDay} ${endMonthShort} ${endYear}`;
  if (endMonth !== startMonth) return `${startDay} ${startMonthShort} -  ${endDay} ${endMonthShort} ${endYear}`;

  return `${startDay}-${endDay} ${startMonthShort} ${startYear}`;
}

function formatDate(dateStr: string) {
  const date = new Date(dateStr);
  const startDay = date.getDate();
  const startMonth = date.toLocaleString(navigator.language, { month: 'short' });
  const startYear = date.getFullYear();

  return `${startDay} ${startMonth} ${startYear}`;
}

function getTimeDiff(date1: string, timeSpan: number) {
  const startDate = new Date(date1);
  const seconds = (startDate.getTime() + timeSpan - startDate.getTime()) / 1000;
  return seconds;
}

function compareDates(time: string) {
  const endTime = new Date(time);
  if (+endTime <= +new Date()) return true;
  return false;
}

export { formatDateRange, formatDate, getTimeDiff, compareDates };
